module.exports = __webpack_public_path__ + "img/kiosk-map-wayfinder.159988bc.webp";